// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Layout_visuallyHidden__R8b3j","stars":"Layout_stars__8STF9","container":"Layout_container__TVB4_","spinner":"Layout_spinner__qSAg7"};